// extracted by mini-css-extract-plugin
module.exports = {"popup-container-class":"search_popup-container-class__18AXt","popup-content-title":"search_popup-content-title__EnIiu"};